import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'ps-ui-qbp-feature-unavailable-tooltip',
  template: `
    <ng-template [ngIf]="show">
      <ps-ui-custom-tooltip [direction]="direction">
        <i
          psUiTooltipTarget
          class="fa fa-exclamation-triangle text-warning"
          aria-hidden="true"
        ></i>
        <p psUiTooltipContent class="text-white">
          QBP feature is not available in a survey with multiple quotas nesting
        </p>
      </ps-ui-custom-tooltip>
    </ng-template>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QbpFeatureUnavailableTooltipComponent {
  @Input()
  show: boolean = false;

  @Input()
  direction: 'left' | 'right' = 'right';

  @Input()
  reason: string = '';
}
